import React from 'react';
import { Link } from 'react-router-dom';
import HeaderSlider from './HeaderSlider';

const About = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <HeaderSlider src="./assets/img/abt-img.jpg" title="About Octopuss" />

                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>About Us</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}



            {/* <!-- About Page Start --> */}



            <section className="bleezy-about-page" style={{ marginTop: '30px' }}>
                <div className="container">
                    <div className="row">
                        {/* <div className="col-md-6">
                            <div className="about-right">
                                <img src="assets/img/Gallery/Bouncer3.jpeg" alt="about image" />
                            </div>
                        </div> */}
                        <div className="col-md-12">
                            <div className="about-left">
                                <h2 className='heading-with-border'>Welcome to OCTOPUSS SECURITY</h2>
                                <p className="octo-para">
                                    OCTOPUSS SECURITY, a premier ISO 9001:2015 Certified Security Group Company, provides wide range of Security, Manpower and  House-Keeping related services. It includes – Armed & Unarmed Manned Guarding Services; Cash Van Service; Bouncer & Bodyguard Service; Event Security Management; Skilled & Unskilled Manpower Service; Temporary Staffing; Facility Management; Housekeeping Services.
                                </p>
                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    We are the best security guards service provider company in India. We are passionate about our work and truly believe in offering best of services to our clients at the most affordable cost. We continuously upgrade and improve ourselves to give you best in security. Our philosophy is giving “Security beyond Guarding” experience to our clients. We truly believe that Security is much more than mere deployment and monitoring of guards. It involves thorough identification of roles and responsibilities of each guard and providing training to enable them to perform their duties in most efficient and productive manner. We aim to make your investment on security more productive by supplementing security guard responsibilities with important roles in the best interest of the company and with an aim to relieve the management completely of security and all allied problems. Our security guard service is most sought after services in India.
                                </p>

                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    We provide integrated solution to our clients by combining Security, Housekeeping and Manpower services under one roof and thereby enabling our clients to avoid multiple vendors and deal only with us for all such non-core task.
                                </p>

                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    We are securing various Corporates, Banks & Financial Institutions, Retail Outlets, Industrial Units, Residential and Commercial Buildings, Hospitals, Educational and Government Institutions. Our relentless efforts have been lauded by our prestigious clients.
                                </p>

                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    Octopuss Security is securing every business vertical 365 days a year. No two security requirements are same. Each business comes with their own unique needs, that influence the nature and type of security solutions that we deliver to them. You can count us as your trusted security partner for your business continuity plan.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* <!-- About Page End --> */}







            {/* <!-- Statement Bottom Area Start --> */}
            <section className="bleezy-about-page" style={{ marginBottom: '30px' }}>
                <div className="container">
                    <div className="row">
                        {/* <div className="col-md-4">
                            <div className="about-right">
                                <img src="assets/img/Gallery/Bouncer2.jpeg" alt="about image" />
                            </div>
                        </div> */}
                        <div className="col-md-12">
                            <div className="about-left">
                                <h2 className='heading-with-border'>SALIENT FEATURES OF OUR SERVICES</h2>
                                <ul class="list">
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  We deploy our personnel in Terry cot Uniform completes from headgear to footwear.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  We also provide free of cost monsoon wear to our staffs.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  Our staff will not be a member of any union, and you will find them most honest, disciplined, loyal and well mannered in all respects.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  We are responsible for all statutory liabilities to our staff from time to time.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  We have with us trained and expert field staff who looks after supervision and surprise checks of personnel deployed for duties.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  We ensure that there will not by any theft or pilferage due to negligence or direct Complicity of your staff.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  We reserve the right to replace any of our staff by providing suitable relief.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  We are capable to provide additional strength of security personnel at a very short notice to our clients.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  We also do free of cost liaison work for our clients in respect of the security matters.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  We have with us trained detectives and our clients may avail their services at cheaper rates to investigate the matter like fraud , theft burglary etc.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  Before deploying our staff for duties, we give them training in Fire-Fighting, Industrial Security and Intelligence work</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  Alertness and smartness of our staff will give you warmth pleasure on gate an elsewhere.</li>
                                    <li className='octo-para'><i class="fa fa-check theme-color"></i>  All our personnel are paid in accordance with Minimum Wages Act and other law Prevailing and leaving no liability whatsoever on the principal employer.</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="bleezy-about-page" style={{ marginBottom: '30px' }}>
                <div className="container">
                    <div className="row">
                        <div className='container-card about-left'>
                            <div className='mission-vision-card'>
                                <h2 className='heading-with-border'>VISION :</h2>
                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                “To liberate our clients from non-core competency task by providing holistic service of Security, Facility Management and Manpower Service under one roof and to deliver highest levels of professionalism, creative solutions and timely responsive services to our clients.”
                                </p>
                            </div>
                            <div className='mission-vision-card'>
                                <h2 className='heading-with-border'>MISION :</h2>
                                <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                                    “To delight our clients by offering truly comprehensive and customized services which cater to even smallest need of each client and providing high quality service by delivering value for money to our clients.”
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* <!-- Statement Bottom Area End --> */}
        </>
    )
}

export default About;
